import {combine, createStore} from 'effector';

export const $applications = createStore({data: [], count: 0})
export const $applicationsTable = createStore({
    limit: 10,
    offset: 0,
    page: 0,
    first: 0
})

export const $selectedApplication = createStore(null)
export const $applicationInfo = createStore(null)

export const $applicationCategories = createStore({count: 0, results: []})
export const $appCatsSelOpts = combine($applicationCategories, ({results}) => {
    return results.map((cat) => ({
        label: cat.name,
        value: cat.id
    }))
})